/**
 * Dynamic API URL resolution for chatapp3
 */

export function getApiUrl(): string {
    // Check for explicit override first
    if (import.meta.env.VITE_API_URL) {
        return import.meta.env.VITE_API_URL;
    }

    // In production (non-localhost), warn if API URL is not configured
    if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        console.warn('[api-url] VITE_API_URL not configured. Backend API may not be accessible in production.');
    }

    // Default to multi-tenant server on port 3001 (for local development)
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    return `${protocol}//${hostname}:3001`;
}

/**
 * @deprecated WebSocket is no longer used. Use SSE streaming via getApiUrl() instead.
 * Kept for backward compatibility with any remaining references.
 */
export function getWsUrl(): string {
    console.warn('[api-url] getWsUrl() is deprecated. SSE streaming is now used via getApiUrl()');
    // Return API URL since WebSocket is no longer used
    return getApiUrl();
}
